import { LOCALITY_DIRECTORY_BY_TYPE_PAGE, LOCALITY_PAGE } from '@/constants/urls';
import { useRouter } from '@/hooks/useRouter';

type TUseIsLocalityPage = {
  isLocalityPage: boolean;
  isLocalityDirectoryByTypePage: boolean;
};

export const useIsLocalityPage = (): TUseIsLocalityPage => {
  const router = useRouter();

  return {
    isLocalityPage: router.pathname.startsWith(LOCALITY_PAGE),
    isLocalityDirectoryByTypePage: router.pathname.startsWith(LOCALITY_DIRECTORY_BY_TYPE_PAGE),
  };
};
